import {Module} from "vuex";
import {RootState} from "@/store";

interface ClientState {
    searchQuery: string;
    statusFilter: boolean;
    officeFilter: number;
    pageSize: number;
    pageNumber: number;
    sortBy: string;
    sortDesc: boolean;
}

const clients: Module<ClientState, RootState> = {
    namespaced: true,
    state: {
        searchQuery: '',
        statusFilter: true,
        officeFilter: 0,
        pageSize: 10,
        pageNumber: 0,
        sortBy: 'nextAppointment',
        sortDesc: false,
    },
    getters: {
        getSearchQuery: (state) => state.searchQuery,
        getStatusFilter: (state) => state.statusFilter,
        getOfficeFilter: (state) => state.officeFilter,
        getPageSize: (state) => state.pageSize,
        getPageNumber: (state) => state.pageNumber,
        getSortBy: (state) => state.sortBy,
        getSortDesc: (state) => state.sortDesc,
    },
    mutations: {
        SET_SEARCH_QUERY(state, query: string) {
            state.searchQuery = query || '';
        },
        SET_STATUS_FILTER(state, status: boolean) {
            state.statusFilter = status;
        },
        SET_OFFICE_FILTER(state, office: number) {
            state.officeFilter = office || 0;
        },
        SET_PAGE_SIZE(state, pageSize: number) {
            state.pageSize = pageSize;
        },
        SET_PAGE_NUMBER(state, pageNumber: number) {
            state.pageNumber = pageNumber;
        },
        RESET_PAGE_NUMBER(state) {
            state.pageNumber = 0;
        },
        SET_SORT_BY(state, sortBy: string) {
            state.sortBy = sortBy || 'nextAppointment';
        },
        SET_SORT_DESC(state, sortDesc: boolean) {
            state.sortDesc = sortDesc;
        },
        RESET_FILTERS(state) {
            state.searchQuery = '';
            state.statusFilter = true;
        }
    }
}

export default clients;